module.exports = __webpack_public_path__ + "img/partners_4.24dffffd.png";